import React, { useState } from 'react';
import './Header.css';
import individual from '../AssetHeader/Frame.svg';
import policyLogo from '../AssetHeader/PP Logo 04 2.svg';
import hamburger from '../AssetHeader/hamburger.svg';
import healthInsuranceImg from "../AssetHeader/Group (1).svg";
import termInsurance from "../AssetHeader/Frame (1).svg";
import carInsurance from "../AssetHeader/Group (3).svg";
import bikeInsurance from "../AssetHeader/Frame (1).svg";
import savingPlan from "../AssetHeader/Frame (2).svg";
import IndividualM from '../AssetHeader/IndividualM.svg';
import BuisnessM from '../AssetHeader/BuisnessM.svg';
import ClaimM from '../AssetHeader/ClaimM.svg'
import AboutM from '../AssetHeader/AbouM.svg';
import Travel from '../AssetHeader/Travel.svg';
import { Link } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState({
    individual: false
  });

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = (menu) => {
    setDropdownOpen({
      ...dropdownOpen,
      [menu]: !dropdownOpen[menu]
    });
  };

  return (
    <div className="navbar-main">
      <img
        src={hamburger}
        alt="hamburger"
        className="hamburger"
        onClick={toggleMenu}
      />
      <div className="policy_logo">
        <a href='https://www.policyplanner.com/'><img src={policyLogo} alt="policy logo" /></a>
      </div>
      <div className="nav-group1">
        <div className="dropdown" onClick={() => toggleDropdown('individual')}>
          <span>
            Individual Insurance
            <img src={individual} className="individual-product-items-with-arrow" alt="arrow" />
          </span>
          {dropdownOpen['individual'] && (
            <div className="dropdown-content">
              <div>
                <img src={healthInsuranceImg} alt="" />
                <a href="https://policyplanner.com/health-insurance.php">Health Insurance</a>
              </div>
              <div>
                <img src={termInsurance} alt="" />
                <a href="https://policyplanner.com/enquiry/term-insurance.php">Term Insurance</a>
              </div>
              <div>
                <img src={carInsurance} alt="" />
                <a href="https://www.policyplanner.com/Motor_Insurance/car-insurance.php">Car Insurance</a>
              </div>
              <div>
                <img src={bikeInsurance} alt="" />
                <a href="https://www.policyplanner.com/Motor_Insurance/bike-insurance.php">Bike Insurance</a>
              </div>
              <div>
                <img src={savingPlan} alt="" />
                <a href="https://policyplanner.com/enquiry/saving-plan.php">Saving Plan</a>
              </div>
              <div>
                <img src={Travel} alt="" />
                <a href="https://policyplanner.com/enquiry/travel-insurance.php">Travel Insurance</a>
              </div>
            </div>
          )}
        </div>
        <div className='smeInsuranceHeading' style={{ color: "red" }}> <Link to='/'> Business/SME Insurance</Link></div>

        <a href='https://www.policyplanner.com/claim.php'><div className="claim" style={{ color: "black" }}>Claim Assistance</div></a>
      </div>
      <div className="nav-group2">
        <a href='https://www.policyplanner.com/about-us.php'><div className='aboutusheading' style={{ color: "black" }}>About Us</div></a>
        {/* <div className="posp">Become a PoSP</div> */}
        <button>Login</button>
      </div>

      {/* Mobile View */}
      {menuOpen && (
        <div className="mobile-view">
          <div className="mobile-view-items">
            <div className="mobile-view-items-with-arrow">
              <img src={IndividualM} alt="Individual" />
              <p onClick={() => toggleDropdown('individual')}>Individual Insurance</p>
              <img src={individual} alt="arrow" onClick={() => toggleDropdown('individual')} />
            </div>
            {dropdownOpen['individual'] && (
              <div className="mobile-dropdown-content">

                <div className="list">
                  <img src={carInsurance} alt="" />
                  <a href="https://www.policyplanner.com/Motor_Insurance/car-insurance.php">Car Insurance</a>
                </div>
                <div className="list">
                  <img src={bikeInsurance} alt="" />
                  <a href="https://www.policyplanner.com/Motor_Insurance/bike-insurance.php">Bike Insurance</a>
                </div>
                <div className="list">
                  <img src={healthInsuranceImg} alt="" />
                  <a href="https://policyplanner.com/health-insurance.php">Health Insurance</a>
                </div>
                <div className="list">
                  <img src={termInsurance} alt="" />
                  <a href="https://policyplanner.com/enquiry/term-insurance.php">Term Insurance</a>
                </div>
                <div className="list">
                  <img src={savingPlan} alt="" />
                  <a href="https://policyplanner.com/enquiry/saving-plan.php">Saving Plan</a>
                </div>
                <div className="list">
                  <img src={Travel} alt="" />
                  <a href="https://policyplanner.com/enquiry/travel-insurance.php">Travel Insurance</a>
                </div>
              </div>
            )}
            <div className="mobile-view-items-with-arrow">
              <img src={BuisnessM} alt="Buiness/SME" />
              <p>Business/SME Insurance</p>
            </div>
            <div className="mobile-view-items-with-arrow">
              <img src={ClaimM} alt="Claim" />
              <p>Claim Assistant</p>
            </div>
            <div className="mobile-view-items-with-arrow">
              <img src={AboutM} alt="About" />
              <p>About Us</p>

            </div>

          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
